import { Component, Input } from '@angular/core';
var RichtextComponent = /** @class */ (function () {
    function RichtextComponent() {
    }
    RichtextComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-richtext',
                    template: "<div class=\"a-richtext\" [innerHTML]=\"text\">\r\n</div>\r\n"
                }] }
    ];
    RichtextComponent.propDecorators = {
        text: [{ type: Input }]
    };
    return RichtextComponent;
}());
export { RichtextComponent };
//# sourceMappingURL=richtext.component.js.map